__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "pim21";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/common/http", "20.3.16", () => (__webpack_require__.e("node_modules_angular_common_fesm2022_http_mjs-_e16e0").then(() => (() => (__webpack_require__(8015))))));
			register("@angular/common", "20.3.16", () => (__webpack_require__.e("node_modules_angular_common_fesm2022_common_mjs-_09f70").then(() => (() => (__webpack_require__(7610))))));
			register("@angular/core", "20.3.16", () => (__webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs-_3bdc0").then(() => (() => (__webpack_require__(5699))))));
			register("@angular/forms", "20.3.16", () => (__webpack_require__.e("node_modules_angular_forms_fesm2022_forms_mjs-_0f7c0").then(() => (() => (__webpack_require__(4456))))));
			register("@angular/router", "20.3.16", () => (__webpack_require__.e("node_modules_angular_router_fesm2022_router_mjs-_e5f00").then(() => (() => (__webpack_require__(6039))))));
			register("@ng-bootstrap/ng-bootstrap", "19.0.1", () => (__webpack_require__.e("node_modules_ng-bootstrap_ng-bootstrap_fesm2022_ng-bootstrap_mjs-_1d630").then(() => (() => (__webpack_require__(1795))))));
			register("@ngx-common/ngx-common-pim-components", "2.1.8", () => (__webpack_require__.e("node_modules_ngx-common_ngx-common-pim-components_fesm2022_ngx-common-ngx-common-pim-componen-7946551").then(() => (() => (__webpack_require__(1363))))));
			register("@ngx-translate/core", "17.0.0", () => (__webpack_require__.e("node_modules_ngx-translate_core_fesm2022_ngx-translate-core_mjs-_89910").then(() => (() => (__webpack_require__(8503))))));
			register("angular-auth-oidc-client", "20.0.3", () => (__webpack_require__.e("node_modules_angular-auth-oidc-client_fesm2022_angular-auth-oidc-client_mjs-_66b01").then(() => (() => (__webpack_require__(5114))))));
			register("rxjs", "7.8.2", () => (__webpack_require__.e("node_modules_rxjs_dist_esm_index_js").then(() => (() => (__webpack_require__(5301))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};